<!--
 * @Description: 提货司机审核页
 * @Author: ma.cq
 * @Date: 2020-02-27 13:45:30
 * @LastEditors: ma.cq
 * @LastEditTime: 2020-02-27 15:06:59
 -->
<template>
  <el-dialog
    title="审核"
    :visible.sync="visiable"
    width="600px"
    @close="handleClose">
    <el-form :model="form" ref="form" :rules="rules" label-width="120px">
      <el-form-item label="司机姓名">
        {{form.driverName}}
      </el-form-item>
      <el-form-item label="司机身份证号码">
        {{form.identityCard}}
      </el-form-item>
      <el-form-item label="司机身份证图片">
        <img-view class="img-view" :transfrom="true" :src="form.idCardObverse" />
        <img-view class="img-view" :transfrom="true" :src="form.idCardPositive" />
      </el-form-item>
      <el-form-item label="审核结果" prop="result">
        <el-radio-group v-model="form.result">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="0">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.result === 0" label="驳回原因" prop="reason">
        <el-input v-model="form.reason" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import ImgView from '@/components/imgView/index'
import { mapActions } from 'vuex'

export default {
  name: 'verifyDialog',
  props: ['show', 'formData'],
  components: { ImgView },
  data () {
    return {
      visiable: false,
      form: {
        driverName: '',
        identityCard: '',
        idCardObverse: '',
        idCardPositive: '',
        result: '',
        reason: ''
      },
      rules: {
        result: [
          { required: true, message: '请选择审核结果' }
        ],
        reason: [
          { required: true, message: '请输入驳回原因' }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['getDriver', 'driverAudit']),
    handleSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            accountId: this.form.id,
            auditFlag: this.form.result,
            refuseReason: this.form.reason
          }
          this.driverAudit(params).then(() => {
            this.$message.success('审核成功')
            this.getDriver()
            this.handleClose()
          })
        } else {
          return false
        }
      })
    },
    handleClose () {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visiable = newVal
      if (newVal) {
        this.form = { ...this.formData, result: '', reason: '' }
        this.$refs['form'] && this.$refs['form'].clearValidate()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.img-view{
  width: 150px;
  height: 150px;
  margin-right: 10px;
  float: left;
}
</style>
